import { v4 as uuidv4 } from 'uuid'
import helpers from '@/library/rpcService/api/helpers'

export default {
  overrideRequest: function (axiosConfig) {

  },

  getcalculation: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  getcalculationxp: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  getcalculationxpasync: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  getxp: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  placebets: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  placebetsasync: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
      axiosConfig.transformRequest = [(params, headers) => {
        headers['Idempotency-Key'] = uuidv4()
        return helpers.axiosTransformRequestHandler(params, headers)
      }]
    }
  },

  processbetslipextradata: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'get'
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/XPBetting.js